import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EventListTable from '../components/features/EventListTable';
import { getEventsById } from '../reducers/events/byId';
import { getIsFetching } from '../reducers/search/isFetching';
import { getSearchResults } from '../reducers/search/results';
import { getLocationQuery } from '../reducers/location';

class SearchResultsContainer extends React.PureComponent {
  static propTypes = {
    isFetching: PropTypes.bool,
    results: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      displayVenue: PropTypes.string.isRequired,
      dateTime: PropTypes.shape({
        date: PropTypes.string.isRequired,
        time: PropTypes.string.isRequired,
        epochSeconds: PropTypes.number.isRequired,
      }),
    })),
  };

  static defaultProps = {
    isFetching: true,
    results: [],
  };

  render() {
    const {
      results,
      ...rest
    } = this.props;

    return (
      <EventListTable
        data={results}
        {...rest}
      />
    );
  }
}

let sortedResults;
let prevIds;
let prevEvents;

const getMemoizedResults = (ids, events) => {
  if (ids !== prevIds || events !== prevEvents) {
    prevIds = ids;
    prevEvents = events;

    sortedResults = ids.map(id => events[id]);
  }

  return sortedResults;
};

const mapStateToProps = (state, ownProps) => ({
  results: getMemoizedResults(getSearchResults(state), getEventsById(state)),
  isFetching: getIsFetching(state),
  locationQuery: getLocationQuery(state),
  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsContainer);



// WEBPACK FOOTER //
// ./src/containers/SearchResultsContainer.js